import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: any) => ({
  addButton: {
    background: "black !important",
    color: "white  !important",
    padding: "6px 35px !important",
    "&:hover": {
      background: "black !important",
    },
  },
  counterBtn: {
    background: "black !important",
    color: "white !important",
    borderRadius: "8px 0 0 8px !important",
    padding: "6px !important",
    "&:hover": {
      background: "black !important",
    },
  },
  counterBtnRemove: {
    background: "black !important",
    color: "white !important",
    borderRadius: "0 8px  8px 0 !important",
    padding: "6px !important",
    marginLeft: 0,
    "&:hover": {
      background: "black !important",
    },
  },
  count: {
    position: "absolute",
    top: "0px",
    right: "0px",
    backgroundColor: "red",
    color: "white",
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "16px",
    cursor: "pointer",
  },
  imageContainer: {
    position: "relative",
    width: "100%",
    paddingTop: "100%", // This maintains a square aspect ratio
    overflow: "hidden",
  },
  image: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    cursor: "pointer",
  },
  productName: {
    fontSize: "14px", // Smaller font for the product name
    textAlign:"center",
    marginBottom:"20px"
  },
}));

export default function BasicCard({
  key,
  image,
  productName,
  quantity,
  price,
  increaseQuantity,
  decreaseQuantity,
  brandName
}: any) {
  const classes = useStyles();

  return (
    // width: 10,
    <>
<div onClick={increaseQuantity} style={{ cursor: "pointer" }}>
  <Box className={classes.imageContainer}>
    <img src={image} alt="product image" className={classes.image} />
    {quantity > 0 && (
      <span
        className={classes.count}
        onClick={(e) => {
          e.stopPropagation(); // Prevents event from bubbling up to parent div
          decreaseQuantity();
        }}
      >
        {quantity}
      </span>
    )}
  </Box>
  <>
    <Typography
      variant="body1"
      color="text.secondary"
      gutterBottom
      className={classes.productName}
    >
      {productName + " (" + brandName + ")"}
    </Typography>
    <Typography
      variant="body2"
      color="text.secondary"
      gutterBottom
      className={classes.productName}
    >
      Mrp:- {price}
    </Typography>
  </>
</div>
    </>
  );
}
